


























import { computed, defineComponent } from "@nuxtjs/composition-api";
import { useConfig } from "@wemade-vsf/composables";

export default defineComponent({
  name: "HeaderLogo",
  setup() {
    const { config } = useConfig();
    const logoAlt = computed(
      () => config.value.logo_alt || config.value.store_name || ""
    );
    return {
      logoAlt,
    };
  },
});
